import { ref } from '@vue/composition-api'
import store from '@/store'

export default function useAppHelperTour() {
  const isOpenHelperTour = ref(store.getters['appHelperTour/isOpenHelperTour'])
  const typeHelperTour = ref(store.getters['appHelperTour/typeHelperTour'])

  const toogleAppHelperTour = () => {
    store.dispatch('appHelperTour/toogleIsOpenHelperTour').then(r => {
      isOpenHelperTour.value = r
    })
  }

  const startHelperTour = async () => {
    await store.dispatch('appHelperTour/startHelperTour').then(r => {
      isOpenHelperTour.value = r
    })
    if (store.getters['appHelperTour/typeHelperTour'] === 'Leads') {
      await store.dispatch('appHelperTour/addBeforeStep', {
        value: 'Seus Leads',
        type: 'title',
        beforeStep: type => new Promise((resolve, reject) => {
          resolve('foo')
        }),

      })
    }

    if (store.getters['appHelperTour/typeHelperTour'] === 'fluxo') {
      await store.dispatch('appHelperTour/addBeforeStep', {
        value: '[data-tourTarget="btn-dropdown-add-bloco-fluxo-messagem"]',
        type: 'target',
        beforeStep: type => new Promise((resolve, reject) => {
          const btnCliek = document.querySelector('[data-tourTarget="btn-dropdown-add-bloco-fluxo-messagem"]')
          if (btnCliek) {
            resolve(btnCliek.click())
          } else {
            reject(new Error('btnCliek not found'))
          }
        }),

      })
    }
  }

  return {
    isOpenHelperTour,
    typeHelperTour,
    toogleAppHelperTour,
    startHelperTour,
  }
}
